import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IState {
  isEnabledSearch: boolean;
  debouncedValue: string;
}

const initialState: IState = {
  isEnabledSearch: false,
  debouncedValue: '',
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setIsEnabledSearch(state, action: PayloadAction<boolean>) {
      state.isEnabledSearch = action.payload;
    },
    setDebouncedValue(state, action: PayloadAction<string>) {
      state.debouncedValue = action.payload;
    },
    setDefaultDebouncedValue(state) {
      state.debouncedValue = initialState.debouncedValue;
    },
  },
});

export const { setIsEnabledSearch, setDebouncedValue, setDefaultDebouncedValue } = searchSlice.actions;
export default searchSlice.reducer;
